import React from 'react';

import { UseToastProvider } from '@motorway/motorway-storybook-cra';

import { BreakpointProvider } from '../../../../../components/misc/Breakpoints/Breakpoints';
import Home from '../../../fastlane/home/Home';
import { Claim } from '../../Components/Claim/Claim';
import { GuidesSection as Guides } from '../../Components/GuidesSection/GuidesSection';
import { Hero as HomepageHero } from '../../Components/Hero/Hero';
import { HomepagePartnerLogos } from '../../Components/HomepagePartnerLogos/HomepagePartnerLogos';
import { HowItWorks } from '../../Components/HowItWorks/HowItWorks';
import { NewsAndTools } from '../../Components/NewsAndTools/NewsAndTools';
import { Reviews } from '../../Components/Reviews/Reviews';
import { SocialProof } from '../../Components/SocialProof/SocialProof';
import useShowNewHomepage from '../../Hooks/useShowNewHomepage';

import styles from './Homepage.scss';

const Homepage = () => {
  const { showNewHomepage } = useShowNewHomepage();

  return (
    showNewHomepage
      ? (
        <UseToastProvider>
          <BreakpointProvider>
            <HomepageHero />
            <HowItWorks className={styles.howItWorks} />
            <Claim className={styles.claim} />
            <HomepagePartnerLogos className={styles.partnerLogos} />
            <SocialProof className={styles.socialProof} />
            <Reviews className={styles.reviews} />
            <NewsAndTools className={styles.newsAndTools} />
            <Guides className={styles.guides}/>
          </BreakpointProvider>
        </UseToastProvider>
      )
      : <Home />
  );
};

export default Homepage;
